module.exports = __webpack_public_path__ + "static/media/ESB.043102d5.png";